module.exports = __webpack_public_path__ + "static/img/a076.f1c9259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a076.jpg
// module id = 7NAN
// module chunks = 0